import React from "react";
import TextMenuPage from "../components/TextMenuPage";
import lunchSections, { lunchMenuDate } from "../data/lunchMenu";
import { useI18n } from "../data/i18n";

// Филтър функция – премахва items с active: false и добавя правилния език
const getActiveSections = (sections, lang) => {
  return sections
    .map(section => ({
      title: lang === 'bg' ? section.title : section.title_en,
      items: section.items
        .filter(item => item.active !== false)
        .map(item => ({
          name: lang === 'bg' ? item.name : item.name_en,
          desc: lang === 'bg' ? (item.desc || "") : (item.desc_en || ""),
          weight: lang === 'bg' ? item.weight : item.weight_en,
          price: item.price,
          active: item.active
        }))
    }))
    .filter(section => section.items.length > 0);
};

const LunchMenu = () => {
  const { t, lang } = useI18n();  // ← добави lang
  
  const activeSections = getActiveSections(lunchSections, lang);

  return (
    <TextMenuPage
      label={t("menu.lunch")}
      title={t("menu.lunch")}
      subtitle={`${lunchMenuDate} · ${t("menu.lunch_hours")}`}
      sections={activeSections}
      largeText
    />
  );
};

export default LunchMenu;